import { Link } from "react-router-dom";
import { Badge } from "reactstrap";
import { HiOutlineDocumentText, HiOutlineExclamationCircle } from "react-icons/hi";
import {
    buildRecommendedActionTargetLink,
    formatRecommendedActionDescription,
    formatRecommendedActionDisplayTitle,
    formatRecommendedActionPriorityLabel,
    getRecommendedActionPriorityBadgeStyle,
    resolveRecommendedActionDisplayPriority,
    resolveRecommendedActionLinkTarget,
    resolveRecommendedActionModuleLabel
} from "../../helpers/nextStepsHelpers";

import "./style.scss";

const hexToRgba = (hex, alpha) => {
    const value = String(hex || "").replace("#", "");

    if (value.length !== 6) {
        return `rgba(220, 53, 69, ${alpha})`;
    }

    const red = parseInt(value.slice(0, 2), 16);
    const green = parseInt(value.slice(2, 4), 16);
    const blue = parseInt(value.slice(4, 6), 16);

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

const RecommendedActionItem = ({
    row,
    assetId,
    t,
    showModule = false
}) => {
    const title = formatRecommendedActionDisplayTitle(row);
    const description = formatRecommendedActionDescription(row);
    const moduleLabel = resolveRecommendedActionModuleLabel(row, t);
    const priority = resolveRecommendedActionDisplayPriority(row);
    const badgeStyle = getRecommendedActionPriorityBadgeStyle(priority);
    const target = resolveRecommendedActionLinkTarget(row);
    const href = buildRecommendedActionTargetLink(assetId, target);
    const actionLabel = target?.type === "assessment_question"
        ? t("Go to question")
        : t("Open");
    const context = description && description !== title ? description : "";
    const secondary = showModule
        ? [moduleLabel, context].filter(Boolean).join(" • ")
        : context;
    const Icon = row?.type === "risk" ? HiOutlineExclamationCircle : HiOutlineDocumentText;
    const accent = badgeStyle.backgroundColor;

    return (
        <div className="recommended-action-item">
            <div
                className="recommended-action-item__icon"
                style={{
                    backgroundColor: hexToRgba(accent, 0.12),
                    color: accent
                }}
            >
                <Icon size={18} />
            </div>

            <div className="recommended-action-item__body">
                <div className="recommended-action-item__title">
                    {href ? <Link to={href}>{title}</Link> : title}
                </div>
                {secondary && (
                    <div className="recommended-action-item__secondary">
                        {secondary}
                    </div>
                )}
            </div>

            <div className="recommended-action-item__side">
                <Badge pill style={badgeStyle}>
                    {formatRecommendedActionPriorityLabel(priority, t)}
                </Badge>
                {href ? (
                    <Link
                        to={href}
                        className="btn btn-sm btn-outline-primary recommended-action-item__action"
                    >
                        {actionLabel}
                    </Link>
                ) : null}
            </div>
        </div>
    );
};

export default RecommendedActionItem;
